/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingAddress } from './';
import {
    BillingAddressFromJSON,
    BillingAddressFromJSONTyped,
    BillingAddressToJSON,
} from './';
import type { CompanyIdentityDataResource } from './';
import {
    CompanyIdentityDataResourceFromJSON,
    CompanyIdentityDataResourceFromJSONTyped,
    CompanyIdentityDataResourceToJSON,
} from './';
import type { CompanyLegalInformation } from './';
import {
    CompanyLegalInformationFromJSON,
    CompanyLegalInformationFromJSONTyped,
    CompanyLegalInformationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientLegalEntityBillingInformationResource
 */
export interface ClientLegalEntityBillingInformationResource {
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    legalName?: string;
    /**
     * 
     * @type {BillingAddress}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    address?: BillingAddress;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    legalInformationStatus?: ClientLegalEntityBillingInformationResourceLegalInformationStatusEnum;
    /**
     * 
     * @type {CompanyLegalInformation}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    legalInformationReplacementSuggestion?: CompanyLegalInformation;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    registrationOfficeInformation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    hasMandatoryInformation?: boolean;
    /**
     * True when the client legal entity has been identified and edits of registration/VAT numbers are blocked for CLIENT actors. False otherwise (unidentified, or feature-flag off for the organization).
     * @type {boolean}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    isIdentifierEditLocked?: boolean;
    /**
     * 
     * @type {CompanyIdentityDataResource}
     * @memberof ClientLegalEntityBillingInformationResource
     */
    companyIdentityData?: CompanyIdentityDataResource;
}


/**
 * @export
 */
export const ClientLegalEntityBillingInformationResourceLegalInformationStatusEnum = {
    Match: 'MATCH',
    PartialMatch: 'PARTIAL_MATCH',
    NotSync: 'NOT_SYNC'
} as const;
export type ClientLegalEntityBillingInformationResourceLegalInformationStatusEnum = typeof ClientLegalEntityBillingInformationResourceLegalInformationStatusEnum[keyof typeof ClientLegalEntityBillingInformationResourceLegalInformationStatusEnum];


/**
 * Check if a given object implements the ClientLegalEntityBillingInformationResource interface.
 */
export function instanceOfClientLegalEntityBillingInformationResource(value: object): value is ClientLegalEntityBillingInformationResource {
    return true;
}

export function ClientLegalEntityBillingInformationResourceFromJSON(json: any): ClientLegalEntityBillingInformationResource {
    return ClientLegalEntityBillingInformationResourceFromJSONTyped(json, false);
}

export function ClientLegalEntityBillingInformationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientLegalEntityBillingInformationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalName': json['legalName'] == null ? undefined : json['legalName'],
        'address': json['address'] == null ? undefined : BillingAddressFromJSON(json['address']),
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'legalInformationStatus': json['legalInformationStatus'] == null ? undefined : json['legalInformationStatus'],
        'legalInformationReplacementSuggestion': json['legalInformationReplacementSuggestion'] == null ? undefined : CompanyLegalInformationFromJSON(json['legalInformationReplacementSuggestion']),
        'registrationOfficeInformation': json['registrationOfficeInformation'] == null ? undefined : json['registrationOfficeInformation'],
        'hasMandatoryInformation': json['hasMandatoryInformation'] == null ? undefined : json['hasMandatoryInformation'],
        'isIdentifierEditLocked': json['isIdentifierEditLocked'] == null ? undefined : json['isIdentifierEditLocked'],
        'companyIdentityData': json['companyIdentityData'] == null ? undefined : CompanyIdentityDataResourceFromJSON(json['companyIdentityData']),
    };
}

export function ClientLegalEntityBillingInformationResourceToJSON(value?: ClientLegalEntityBillingInformationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalName': value['legalName'],
        'address': BillingAddressToJSON(value['address']),
        'vatNumber': value['vatNumber'],
        'registrationNumber': value['registrationNumber'],
        'legalInformationStatus': value['legalInformationStatus'],
        'legalInformationReplacementSuggestion': CompanyLegalInformationToJSON(value['legalInformationReplacementSuggestion']),
        'registrationOfficeInformation': value['registrationOfficeInformation'],
        'hasMandatoryInformation': value['hasMandatoryInformation'],
        'isIdentifierEditLocked': value['isIdentifierEditLocked'],
        'companyIdentityData': CompanyIdentityDataResourceToJSON(value['companyIdentityData']),
    };
}

